<template>
  <div>
    <div class="contribution-label mb-4">
      <p class="text-uppercase text-small font-weight-bold mb-2 text-dark">
        {{ $t('knowledge.modals.contribution.subject') }}
      </p>
      <input
        class="subject-input px-3 py-2"
        id="contributionSubjectInput"
        style="font-family: Lato !important; color: grey"
        type="text"
        v-model="subject"
        ref="contributionSubjectInput"
        @keyup.enter="onKeyupEnterSubject"
        @keyup.tab="onKeyupEnterSubject"
      />
    </div>
    <div class="contribution-body">
      <p class="text-uppercase text-small font-weight-bold mb-2 text-dark">
        {{ $t('knowledge.modals.contribution.message') }}
      </p>
      <div>
        <MaydayNotificationEditor
          class="contribution__editor"
          ref="NotificationEditor"
          :placeholder="'knowledge.modals.contribution.message-placeholder'"
          :message="message"
          :editable="true"
          :is-contribution="true"
          @input="sendUpdateMessageEvent"
        />
      </div>
    </div>
    <el-form enctype="multipart/form-data">
      <el-upload
        class="my-3 upload-demo"
        drag
        action=""
        :on-change="updateAttachments"
        :on-remove="updateAttachments"
        :auto-upload="false"
        :show-file-list="true"
        :file-list="fileList"
        multiple
      >
        <img src="~assets/empty-contents.svg" width="100px" />
        <div class="el-upload__text">
          {{ $t('knowledge.modals.contribution.drop-file') }}
          <em>{{ $t('knowledge.modals.contribution.upload') }}</em>
        </div>
      </el-upload>
    </el-form>
    <div class="compliance-disclaimer text-muted">
      ℹ️
      <small>
        Veillez à ne pas saisir dans les zones de commentaire ou dans les
        pièces-jointes d’informations textuelles ou visuelles qui permettent
        d’identifier des personnes physiques directement ou indirectement (noms,
        photographies…).</small
      >
    </div>
  </div>
</template>

<script>
import MaydayNotificationEditor from '@/components/Editors/MaydayNotificationEditor';

export default {
  name: 'contribution-edition',
  components: {
    MaydayNotificationEditor,
  },
  data() {
    return {
      subject: '',
      message: '',
      attachments: [],
      fileList: [],
    };
  },
  mounted() {
    this.$refs['contributionSubjectInput'].focus();
  },
  methods: {
    updateAttachments(file, fileList) {
      this.attachments = fileList.map((file) => file.raw);
      this.fileList = fileList;
      this.$emit('update-message', {
        label: this.subject,
        body: this.message === '<p></p>' ? '' : this.message,
        attachments: this.attachments,
      });
    },
    onKeyupEnterSubject() {
      if (this.subject.length > 0) {
        this.$refs['NotificationEditor'].focusEditor();
      }
    },
    sendUpdateMessageEvent(message) {
      this.message = message === '<p></p>' ? '' : message;
      this.$emit('update-message', {
        label: this.subject,
        body: this.message,
        attachments: this.attachments,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subject-input {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding-left: 4px;
  width: 100%;
}
.text-small {
  color: $grey-5-mayday;
  font-size: 0.9em;
}

.grey-six {
  color: $grey-6-mayday;
}

.section {
  background-color: $grey-1-mayday;
  border-radius: 4px;

  :deep() .el-cascader {
    width: 90%;
  }
}

.upload-demo {
  text-align: center;

  :deep() .el-upload {
    width: 100%;
  }

  :deep() .el-upload-dragger {
    width: 100%;
    height: 150px;
    padding: 16px;
  }
}

.compliance-disclaimer {
  small {
    font-style: italic;
  }
}

.contribution__editor {
  border: 1px solid $grey-4-mayday;
  border-radius: 4px;
  min-height: 20vh;
}
</style>
